import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BoxGroupInfos } from '../../models/box-group-infos';
import { BoxInfos } from '../../models/box-infos';

@Injectable({
    providedIn: 'root',
})
export class BoxesStateService {
    private onBoxesSelectionChange = new Subject<BoxInfos[]>();

    private onBoxesListChange = new BehaviorSubject<BoxInfos[]>([]);

    private onBoxCounterChange = new BehaviorSubject<BoxInfos>(null);

    /**
     * Emet un événement lorsque le nombre de dossiers d'une bannettes change.
     */
    public get onBoxCounterChange$() {
        return this.onBoxCounterChange.asObservable();
    }

    /**
     * Emet un événement lorsqu'une ou plusieurs bannettes sont sélectionnées ou deselectionnées.
     */
    public get onBoxesSelectionChange$() {
        return this.onBoxesSelectionChange.asObservable();
    }

    /**
     * Emet un événement lorsque la liste des banettes change.
     */
    public get onBoxesListChange$() {
        return this.onBoxesListChange.asObservable();
    }

    /**
     * Retourne la liste des des bannettes selectionnées.
     * @returns La liste des des bannettes selectionnées.
     */
    public getSelectedBoxes(): BoxInfos[] {
        return this.getBoxesList().filter((x) => x.selected === true);
    }

    /**
     * Indique que l'état selectionné / deselectionné d'une ou plusieurs bannettes a changé.
     * @param boxes: Tableau des bannettes dont l'état a changé.
     */
    public updateBoxesSelectionState(boxes: BoxInfos[]) {
        this.onBoxesSelectionChange.next(boxes);
    }

    /** Decremente le compteur d'une bannette*/
    public decrementBoxCounter(boxId: string, increment: number) {
        const boxInfos = this.getBoxesList().find((b) => b.id == boxId);
        boxInfos.count = boxInfos.count - increment;
        this.updateBoxCount(boxInfos);
    }

    /** Incrémente le compteur d'une bannette */
    public incrementBoxCounter(boxId: string, increment: number) {
        const boxInfos = this.getBoxesList().find((b) => b.id == boxId);
        boxInfos.count = boxInfos.count + increment;
        this.updateBoxCount(boxInfos);
    }

    // Retourne la liste des bannettes.
    public getBoxesList(): BoxInfos[] {
        return this.onBoxesListChange.value;
    }

    // Spécifie la liste des bannettes.
    private setBoxesList(boxes: BoxInfos[]) {
        this.onBoxesListChange.next(boxes);
    }

    private boxesGroups: BoxGroupInfos[];

    // Retourne la liste des groupes de bannettes.
    public getBoxesGroupsList(): BoxGroupInfos[] {
        return this.boxesGroups;
    }

    // Spécifie la liste des groupes de bannettes.
    public setBoxesGroupsList(boxesGroups: BoxGroupInfos[]) {
        this.boxesGroups = boxesGroups;

        const boxesList: BoxInfos[] = [];

        boxesGroups.forEach((bg) => {
            boxesList.push(...bg.boxes);
        });

        this.setBoxesList(boxesList);
    }

    /** Mise à jour d'un compter de bannette */
    public updateBoxCount(box: BoxInfos) {
        this.onBoxCounterChange.next(box);
    }
}
